import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IUsuarioRegistrarModel } from './models/interfaces/seguridad/IUsuarioRegistrarModel';
import { UsuarioRegistrarModel } from './models/seguridad/UsuarioRegistrarModel';
import { OktaAuthService } from './services/OktaAuth/okta-auth.service';
import { AutenticacionService } from './services/seguridad/autenticacion/autenticacion.service';
import { SeguridadUsuarioService } from './services/seguridad/seguridad-usuario.service';
import { StorageService } from './services/storage/storage.service';

// import { AuthenticationService } from '@/_services';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AutenticacionService,
        private storageService: StorageService,
        private oktaService: OktaAuthService,
        private seguridadUsuarioService: SeguridadUsuarioService,
    ) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // const currentUser = this.authenticationService;
        const isAuthenticated = await this.oktaService.isAuthenticated();
        // var user = this.storageService.getCurrentUser();

        let user: IUsuarioRegistrarModel = new UsuarioRegistrarModel();

        
        //  .subscribe((q) => {
        //     user = q;
        //     console.log(user);  
        // });
        
        if (isAuthenticated) {
            // console.log("Is Authenticated");
            
            user = await this.seguridadUsuarioService.getCurrent().toPromise();

            if(user.selectedRoles){
                // console.log(user.selectedRoles);
                if(user.selectedRoles.length > 0)
                {
                    if(route.data.roles){
                        var hasRol = route.data.roles.some((r: number) =>  user.selectedRoles.includes(r));   
                        // console.log(hasRol);
                        if (!hasRol) {
                            // role not authorised so redirect to home page
                            this.router.navigate(['/acceso-denegado']);
                            return false;
                        }
                    }
                }
                else {
                    if(route.data.roles){
                        // role not authorised so redirect to home page
                        this.router.navigate(['/acceso-denegado']);
                        return false;
                    }
                }          
                return true;
            }
            else {
                if(route.data.roles){
                    // role not authorised so redirect to home page
                    this.router.navigate(['/acceso-denegado']);
                    return false;
                }
                else {
                    return true;
                }
            } 
        }
        else 
        {
            const isAuthenticatedContratista = this.storageService.isAuthenticated()
            if(isAuthenticatedContratista){
                user = await this.seguridadUsuarioService.getCurrent().toPromise();
                
                if(user.selectedRoles){
                    if(user.selectedRoles.length > 0)
                    {
                        if(route.data.roles){
                            var hasRol = route.data.roles.some((r: number) =>  user.selectedRoles.includes(r));
                            if (!hasRol) {
                                // role not authorised so redirect to home page
                                this.router.navigate(['/acceso-denegado']);
                                return false;
                            }
                        }
                    }
                    else
                    {
                        if(route.data.roles){
                            // role not authorised so redirect to home page
                            this.router.navigate(['/acceso-denegado']);
                            return false;
                        }
                    }
                    return true;
                }
                else {
                    if(route.data.roles){
                        // role not authorised so redirect to home page
                        this.router.navigate(['/acceso-denegado']);
                        return false;
                    }
                    else {
                        return true;
                    }
                }
            }
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}